import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = (resource) => {
  return [
    <MenuItem primaryText='Edit' key='edit' value={`/write-now/sessions/${resource.id}/edit`} />,
    <MenuItem primaryText='Copy' key='copy' value={`/write-now/sessions/${resource.id}/copy`} />,
    <MenuItem primaryText='Groups' key='groups' value={`/write-now/groups?filters[session_id]=${resource.id}`} />,
    <MenuItem primaryText='Notifications' key='notifications' value={`/write-now/session_notifications?filters[session_id]=${resource.id}`} />
  ]
}

export default buildMenuItems
